export default __webpack_public_path__ + "static/Hero2-9e69e8215f9815e5f6cfe3ce5e862095.jpg";